module.exports = __webpack_public_path__ + "static/media/A9.30c1783b.png";